/**
 * Warning: does not function properly on functions that have additional properties set.
 */
export function clone<T>(obj: T, deep = true): T {
  if (typeof obj !== 'object' || !obj || typeof obj === 'function') {
    return obj; // primitive or function, can't clone
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime()) as T;
  }

  if (Symbol.iterator in obj) {
    return Array.prototype.map.call(obj, value => deep ? clone(value, deep) : value) as T;
  }

  const newObj = {} as T;

  if ('clone' in obj && typeof obj.clone === 'function') {
    return obj.clone(deep);
  }

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = deep ? clone(obj[key], deep) : obj[key];
    }
  }

  return newObj;
}